import { render, staticRenderFns } from "./afterSalesManagement.vue?vue&type=template&id=beada546&scoped=true&"
import script from "./afterSalesManagement.vue?vue&type=script&lang=js&"
export * from "./afterSalesManagement.vue?vue&type=script&lang=js&"
import style0 from "./afterSalesManagement.vue?vue&type=style&index=0&id=beada546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beada546",
  null
  
)

export default component.exports